import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const SMS = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.45455 3C3.54665 3 2 4.51258 2 6.37844V14.1722C2 16.038 3.54665 17.5506 5.45455 17.5506H5.99699C6.64924 17.5506 7.17598 18.0832 7.16883 18.7354C7.1584 19.6861 8.22487 20.2529 9.00701 19.7122L11.4407 18.0301C11.8923 17.7178 12.4284 17.5506 12.9775 17.5506H17.5455C19.4533 17.5506 21 16.038 21 14.1722V6.37844C21 4.51258 19.4533 3 17.5455 3H5.45455ZM5.40234 7.8146C5.40234 7.36471 5.76705 7 6.21694 7H10.3066C10.7565 7 11.1212 7.36471 11.1212 7.8146C11.1212 8.26449 10.7565 8.62919 10.3066 8.62919H6.21694C5.76705 8.62919 5.40234 8.26449 5.40234 7.8146ZM6.21694 10.2583C5.76705 10.2583 5.40234 10.623 5.40234 11.0729C5.40234 11.5228 5.76705 11.8875 6.21694 11.8875H16.0254C16.4753 11.8875 16.84 11.5228 16.84 11.0729C16.84 10.623 16.4753 10.2583 16.0254 10.2583H6.21694Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default SMS;
